import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { companyInfo } from '../data/mock';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  type = 'website'
}) => {
  const location = useLocation();
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://armedsecurityservice.com';
  const fullUrl = `${siteUrl}${location.pathname}`;
  const ogImage = image || `${siteUrl}/og-image.jpg`;
  const metaDescription = description || companyInfo.description;
  const metaTitle = title ? `${title} | ${companyInfo.name}` : `${companyInfo.name} - ${companyInfo.tagline}`;
  const metaKeywords = keywords || 'armed security guards, unarmed security, security services, fire watch, event security, commercial security, bodyguards, private security, security company, nationwide security, 24/7 security, licensed security guards, bonded security, insured security';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{metaTitle}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content={companyInfo.name} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={companyInfo.name} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional SEO */}
      <meta name="geo.region" content="US" />
      <meta name="geo.placename" content="United States" />
      
      {/* Business Information */}
      <meta name="contact" content={companyInfo.email} />
      <meta name="phone" content={companyInfo.phone} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO;
